import { Link } from 'react-router-dom';
import { ScrollReveal } from '@/components/ui/scroll-reveal';

export function BeforeAfter() {
  return (
    <section className="relative py-28 bg-charcoal-deep overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <ScrollReveal direction="left" className="relative">
          <div className="absolute -inset-4 bg-electric/20 blur-3xl" />
          <div className="relative skew-card overflow-hidden border-4 border-thunder glow-thunder">
            <div className="skew-inner aspect-[4/5]">
              <img
                src="/images/heroes/hero-3-before-after.webp"
                alt="Before and after cleaning transformation"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="absolute top-6 -right-4 bg-thunder text-charcoal-deep font-display font-bold px-6 py-3 tracking-[0.2em] text-sm glow-thunder">
            BEFORE / AFTER
          </div>
        </ScrollReveal>

        <ScrollReveal direction="right">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-thunder" />
            <span className="text-thunder font-display tracking-[0.4em] text-xs">// THE TRANSFORMATION</span>
          </div>
          <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mb-8">
            SEE THE <span className="text-electric">DIFFERENCE.</span>
            <span className="block mt-2">FEEL THE </span>
            <span className="text-electric">BOOM.</span>
          </h2>
          <p className="text-white/70 text-lg leading-relaxed mb-8">
            Every transformation is earned — never staged. Ceiling fans to baseboards, methodically, until the space passes inspection.
          </p>
          <ul className="space-y-3 mb-10">
            {['Detail-first methodology', 'Photo documentation on request', 'Same-crew consistency', 'Eco-safe products available'].map((t) => (
              <li key={t} className="flex items-center gap-4 text-white/80 font-display tracking-wider text-sm">
                <span className="text-electric text-xl">&#x25B8;</span>
                <span>{t}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/contact"
            className="inline-block bg-thunder hover:bg-thunder-dark text-charcoal-deep font-display font-bold px-8 py-4 tracking-[0.25em] text-sm transition"
          >
            REQUEST A WALKTHROUGH →
          </Link>
        </ScrollReveal>
      </div>
    </section>
  );
}
